export default "__VITE_ASSET__CVU2xGRH__"